export enum Scope {
  None = 0,
  CountryAdmin = 1,
  OrganizationAdmin = 2,
  OrganizationMember = 4,
  GlobalAdmin = 512,
}
